import { useEffect, useMemo } from "react";
import { remarkStyle, head, signature } from "../helper";
import DefaultImage from "../../../../images/Navbar/2xcell-signature.png";
import { htmlDecode } from "../../../../utils/parse";
import { QuestionImg } from "../Image";

import "./Question.css";

function Description({ image, description }) {
  return (
      <div className="description">
        {image ? <QuestionImg image={image} /> : null}
        <p
          dangerouslySetInnerHTML={{
            __html: htmlDecode(description),
          }}
        ></p>
      </div>
  );
}

export default function Question({
  color = "",
  index,
  label,
  question,
  children,
  alignOptions = ""
}) {
  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [question]);

  const language = useMemo(() => {
   return question.language && question.language.toLowerCase();
  },[question.language]);

  return (
    <div className="question">
      <div className="label" style={remarkStyle(color)}>
        {label}
      </div>
      <div className="question-body" style={head(color)}>
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: htmlDecode(`Q${index}. ${question.question}`),
          }}
        ></div>
        {question.description?.assertion ? (
            <Description
              description={`${language === "hindi"?"कथन (A)":"Assertion (A)"}: ${question.description?.assertion || ""}`}
              image={question.assertImg}
            />
          ) : null}
          {question.description?.reasoning ? (
            <Description
              description={`${language === "hindi"?"कारण (R):":"Reasoning (R)"} ${question.description?.reasoning || ""}`}
              image={question.reasonImg}
            />
          ) : null}
        <div className="question-content">
          <QuestionImg image={question.images?.questionImg} />
          <div className={`question-fields ${alignOptions}`}>{children}</div>
        </div>
        {["filup", "oneword"].includes(question.questionType) ? (
          <p style={{ fontSize: "0.7rem", margin: 0 }}>
            Tip: Use the math editor for writing formulas.
          </p>
        ) : null}
        <div className="signature">
          {question.onModel === "admin" ? (
            <img
              src={DefaultImage}
              className="content"
              style={{
                ...signature(color),
                width: "100px",
                aspectRatio: "auto",
                height: "fit-content",
              }}
            />
          ) : (
            <div className="content" style={signature(color)}>
              {question?.creatorId ? question.creatorId.name : ""}
              <br />
              {question?.schoolId?.name}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
